import { MobXProviderContext } from 'mobx-react';
import { ContactModelBase } from 'Models/ContactModel';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { PresenceModel } from 'Models/PresenceModel';
import MessageStatusModel from 'Models/StatusModel';
import { useContext } from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';

export interface useContactInfoProps {
  contact: ContactModelV2 | ContactModelBase;
}

export interface useContactInfoReturn {
  name: string;
  image: string;
  statusMessage: MessageStatusModel;
  presence: PresenceModel | null;
}

export const useContactInfo = ({
  contact,
}: useContactInfoProps): useContactInfoReturn => {
  const { ui: uiStore } = useContext(MobXProviderContext) as RootStoreProps;

  const name =
    contact instanceof ContactModelV2
      ? contact.name || ''
      : contact.DisplayName || '';

  const image =
    contact instanceof ContactModelV2 ? contact.avatarUrl || '' : '';

  const statusMessage =
    contact instanceof ContactModelV2 && contact.source === 'Bhive'
      ? uiStore.selectPersonMessageStatus(contact.sourceId)
      : null;

  const presence =
    contact instanceof ContactModelV2 && contact.source === 'Bhive'
      ? uiStore.selectPersonPresenceStatus(contact.sourceId)
      : null;

  return {
    name,
    image,
    presence,
    statusMessage,
  };
};
